var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from "clsx";
import React, { forwardRef } from "react";
import { ChevronRightIcon } from "@navikt/aksel-icons";
import { Panel } from "../panel";
import { LinkPanelDescription, } from "./LinkPanelDescription";
import { LinkPanelTitle } from "./LinkPanelTitle";
/**
 * A component that displays a link panel.
 *
 * @see [📝 Documentation](https://aksel.nav.no/komponenter/core/linkpanel)
 * @see 🏷️ {@link LinkPanelProps}
 * @see [🤖 OverridableComponent](https://aksel.nav.no/grunnleggende/kode/overridablecomponent) support
 *
 * @example
 * ```jsx
 * <LinkPanel href="#" border>
 *   <LinkPanel.Title>Arbeidssøker eller permittert</LinkPanel.Title>
 *   <LinkPanel.Description>
 *     Om jobb, registrering, CV, dagpenger og feriepenger av dagpenger
 *   </LinkPanel.Description>
 * </LinkPanel>
 * ```
 */
export const LinkPanelComponent = forwardRef((_a, ref) => {
    var { children, as = "a", border = true, className } = _a, rest = __rest(_a, ["children", "as", "border", "className"]);
    return (React.createElement(Panel, Object.assign({}, rest, { as: as, border: border, ref: ref, className: cl("navds-link-panel", className) }),
        React.createElement("div", { className: "navds-link-panel__content" }, children),
        React.createElement(ChevronRightIcon, { className: "navds-link-panel__chevron", "aria-hidden": true })));
});
const LinkPanel = LinkPanelComponent;
LinkPanel.Title = LinkPanelTitle;
LinkPanel.Description = LinkPanelDescription;
export default LinkPanel;
//# sourceMappingURL=LinkPanel.js.map